import { useMemo, useEffect } from 'react';
import EventEmitter from 'granite-admin/utils/event-emitter';
function useEmitter(listner) {
  const eventEmitter = useMemo(() => new EventEmitter(), []);
  useEffect(() => {
    const subsribers = typeof listner === 'function' ? listner : function () {};
    const subscription = eventEmitter.getObservable().subscribe(subsribers);
    return () => subscription.unsubscribe();
  }, [eventEmitter, listner]);
  return eventEmitter;
}
export default useEmitter;